import { useFormContext } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CommonFields from "components/CommonFields";
import { INPUT_TYPE } from "globalConstants";
import { getInvoiceValueFromBasicPrice, getLtvFromOwnMargin } from "utils";

const BasicPriceOrInvoiceValue = ({ index }: { index: number }) => {
    const { setValue, watch, clearErrors, setError } = useFormContext();
    const disableInvoiceValue = watch(`requirement.equipments.${index}.disableInvoiceValue`);
    const disableOwnMargin = watch(`requirement.equipments.${index}.disableOwnMargin`);
    const tcsPercentage = watch(`requirement.equipments.${index}.tcsPercentage`);
    const invoiceValue = watch(`requirement.equipments.${index}.invoiceValue`);
    const loanToValue = watch(`requirement.equipments.${index}.loanToValue`);
    const basicPrice = watch(`requirement.equipments.${index}.basicPrice`);
    const OwnMargin = watch(`requirement.equipments.${index}.ownMargin`);

    return (
        <Grid container className="common__or__container" justifyContent="center" alignItems="center">
            <Grid item xs={6}>
                <div className="or__top">
                    <div className="line" />
                    <Typography className="common-mui-accordian__text" data-testid={`invoice-value-equipment-${index + 1}-field-label`}>
                        Invoice value <span style={{ color: "red" }}> *</span>
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={6}>
                <CommonFields
                    name={`requirement.equipments.${index}.invoiceValue`}
                    label=""
                    inputType={INPUT_TYPE.PRICE}
                    placeholder="35,75,400"
                    showLabel={false}
                    shouldAddMarginTop={false}
                    data-testid={`invoice-value-equipment-${index + 1}-field`}
                    reactHookFormRegisterOptions={{
                        onChange: (e) => {
                            const value = e.target.value?.split(",").join("");
                            const invoiceValue = value || 0;
                            // const tcs = +((invoiceValue * tcsPercentage) / (100 + tcsPercentage));
                            const basicPrice = +(invoiceValue / 1.1918).toFixed(2);
                            if (disableOwnMargin) {
                                let ownMargin = +(invoiceValue - invoiceValue * (loanToValue / 100)).toFixed(2);
                                ownMargin = ownMargin > 0 ? ownMargin : 0;
                                setValue(`requirement.equipments.${index}.ownMargin`, `${ownMargin}`);
                            } else {
                                let ltv = getLtvFromOwnMargin({ ownMargin: watch(`requirement.equipments.${index}.ownMargin`), invoiceValue });
                                setValue(`requirement.equipments.${index}.loanToValue`, ltv > 0 ? ltv : 0);
                                if (OwnMargin < invoiceValue) {
                                    clearErrors(`requirement.equipments.${index}.ownMargin`);
                                } else {
                                    setError(`requirement.equipments.${index}.ownMargin`, {
                                        type: "manual",
                                        message: "Own Margin cannot be greater than Equipment Cost",
                                    });
                                }
                            }
                            setValue(`requirement.equipments.${index}.basicPrice`, `${basicPrice}`);
                            setValue(`requirement.equipments.${index}.disableInvoiceValue`, false);
                        },
                    }}
                    readOnly={localStorage.getItem("disable_form") === "true" || (basicPrice && disableInvoiceValue)}
                />
            </Grid>
            <Grid item xs={12}>
                <div className="or__circle">or</div>
            </Grid>
            <Grid item xs={6}>
                <div className="or__bottom">
                    <div className="line" />
                    <Typography className="common-mui-accordian__text" data-testid={`basic-price-equipment-${index + 1}-field-label`}>
                        Basic Price <span style={{ color: "red" }}> *</span>
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={6}>
                <CommonFields
                    name={`requirement.equipments.${index}.basicPrice`}
                    label=""
                    inputType={INPUT_TYPE.PRICE}
                    data-testid={`basic-price-equipment-${index + 1}-field`}
                    reactHookFormRegisterOptions={{
                        onChange: (e) => {
                            const value = e.target.value?.split(",").join("");
                            setValue(`requirement.equipments.${index}.basicPrice`, `${value}`);
                            let invoiceValue = getInvoiceValueFromBasicPrice({ basicPrice: value, tcsPercentage });
                            setValue(`requirement.equipments.${index}.invoiceValue`, `${invoiceValue}`);
                            if (disableOwnMargin) {
                                let ownMargin = +(invoiceValue - invoiceValue * (loanToValue / 100)).toFixed(2);
                                ownMargin = ownMargin > 0 ? ownMargin : 0;
                                setValue(`requirement.equipments.${index}.ownMargin`, `${ownMargin}`);
                            } else {
                                let ltv = getLtvFromOwnMargin({ ownMargin: watch(`requirement.equipments.${index}.ownMargin`), invoiceValue });

                                setValue(`requirement.equipments.${index}.loanToValue`, ltv > 0 ? ltv : 0);
                            }

                            setValue(`requirement.equipments.${index}.disableInvoiceValue`, true);
                        },
                    }}
                    shouldAddMarginTop={false}
                    showLabel={false}
                    placeholder="30,00,000"
                    readOnly={localStorage.getItem("disable_form") === "true" || (invoiceValue && !disableInvoiceValue)}
                />
            </Grid>
        </Grid>
    );
};

export default BasicPriceOrInvoiceValue;
